import { Injectable } from '@angular/core';
import { SubstitutionBoard } from '../../interfaces/interfaces.module';
import { Observable, of } from 'rxjs';
import { QueryStringBuilder } from '@bayclubs/utils';
import { SubBoardHttpClient } from './sub-board-http-client';

@Injectable({
    providedIn: 'root'
})
export class SubBoardApiService {
    constructor(private http: SubBoardHttpClient) {}

    public getDetails(
        clubId: string,
        requestId: string,
        showLoader: boolean = true
    ): Observable<SubstitutionBoard.SubstitutionRequestListItemModel> {
        const url = `clubs/${clubId}/substitution-requests/${requestId}`;
        return this.http.get<SubstitutionBoard.SubstitutionRequestListItemModel>(url, showLoader);
    }

    public list(
        clubId: string,
        query: SubstitutionBoard.GetSubstitutionRequestsQuery
    ): Observable<SubstitutionBoard.SubstitutionRequestListModel> {
        const queryParams = QueryStringBuilder.buildParametersFromSearch(query).toString();
        const queryString = queryParams ? ('?' + queryParams) : '';
        const url = `clubs/${clubId}/substitution-requests${queryString}`;

        return this.http.get<SubstitutionBoard.SubstitutionRequestListModel>(url, true);
    }

    public requestSubstitution(clubId: string, groupClassId: string): Observable<void> {
        const command: SubstitutionBoard.RequestSubstitutionCommand = {
            activityId: groupClassId,
            comment: null
        };
        const url = `clubs/${clubId}/substitution-requests`;
        return this.http.post<void>(url, command, true);
    }

    public confirmInstructorAsSubstitute(clubId: string, substitutionRequestId: string, providerId: string): Observable<any> {
        const url = `clubs/${clubId}/substitution-requests/${substitutionRequestId}/confirm-provider/${providerId}`;
        return this.http.put(url, {}, true);
    }

    public rejectProposal(clubId: string, substitutionRequestId: string, proposalId: string): Observable<any> {
        const url = `clubs/${clubId}/substitution-requests/${substitutionRequestId}/proposals/${proposalId}/reject`;
        return this.http.put(url, {}, true);
    }

    public approveProposal(clubId: string, substitutionRequestId: string, proposalId: string): Observable<any> {
        const url = `clubs/${clubId}/substitution-requests/${substitutionRequestId}/proposals/${proposalId}/confirm`;
        return this.http.put(url, {}, true);
    }

    public getOpenRequest(
        clubId: string,
        groupClassId: string
    ): Observable<SubstitutionBoard.ActivityOpenSubstitutionRequestModel> {
        const url = `clubs/${clubId}/activities/${groupClassId}/open-request`;
        return this.http.get<SubstitutionBoard.ActivityOpenSubstitutionRequestModel>(url, true);
    }

    public cancelSubstitutionRequest(clubId: string, requestId: string): Observable<never> {
        return this.http.put(`clubs/${clubId}/substitution-requests/${requestId}/cancel`, {}, true);
    }
}
